<template>
 <div>
  <div class="detailsTitle">
      <h4>代开合同</h4>
  </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="inpBox">
            <el-form-item label="司机姓名:" >
               <el-input  placeholder="" v-model="searchFrom.partyAName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号:" >
               <el-input  placeholder="" v-model="searchFrom.partyATaxId"></el-input>
            </el-form-item>
            <el-form-item label="签署时间:" prop="signDate">
              <el-date-picker
                v-model="searchFrom.signDates"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="到期:" prop="expireFlag">
                <el-select
                  v-model="searchFrom.expireFlag"
                  placeholder="请选择"
                >
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="未到期" value="0"></el-option>
                  <el-option label="已到期" value="1"></el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
           <el-form-item >
            <el-button type="primary" @click="plxzFn" :disabled="isDisable">下载</el-button>
          </el-form-item>

       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="partyAName"  min-width="150" :formatter="emptyFn"  :show-overflow-tooltip="true" label="司机姓名"></el-table-column>
        <el-table-column prop="partyATaxId" min-width="160" :formatter="emptyFn" label="身份证号"></el-table-column>
        <el-table-column prop="verifyCode"  min-width="200" :formatter="emptyFn" label="代办委托服务协议">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.onePathLook" @click="kookFN(scope.row,1)">查看</el-button>
            <el-button type="text" size="mini" v-if="scope.row.onePathDown" @click="xiazaiFn(scope.row,1)">下载</el-button>
          </template>
        </el-table-column>
         <el-table-column prop="verifyCode"  min-width="200" :formatter="emptyFn" label="委托代开增值税专用发票代缴税款协议">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.threePathLook" @click="kookFN(scope.row,3)">查看</el-button>
            <el-button type="text" size="mini" v-if="scope.row.threePathDown" @click="xiazaiFn(scope.row,3)">下载</el-button>
          </template>
        </el-table-column>
         <el-table-column prop="verifyCode"  min-width="200" :formatter="emptyFn" label="路费通用户服务协议">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="scope.row.twoPathLook" @click="kookFN(scope.row,2)">查看</el-button>
            <el-button type="text" size="mini" v-if="scope.row.twoPathDown" @click="xiazaiFn(scope.row,2)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="signDate" min-width="160" :formatter="dateTimeFormat" label="签署时间"></el-table-column>
        <el-table-column prop="expireDate" min-width="160" :formatter="dateTimeFormat" label="到期时间"></el-table-column>
        <el-table-column prop="verifyCode"  min-width="100"  label="到期">
          <template slot-scope="scope">
              <span>{{ ['未到期','已到期'][scope.row.expireFlag] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { driverAgreementList } from '@/api/common-signature'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { fileDownAll } from '@/utils/fileDownAll.js'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['01F01Y0100', '01F01Y0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/statisticsManagement/driver')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 138) + 'px'
    this.getList(this.searchFrom)
  },
  methods: {
    // 批量下载
    plxzFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.isDisable = true
      let n = 0 // 控制下载按钮是否可用
      selectData.forEach(item => {
        fileDownAll(
          this.global.signature + '//driverAgreement/downLoadZip',
          { id: item.contractId },
          item.partyAName,
          '.zip'
        )
        n++
        if (n == selectData.length) {
          this.isDisable = false
        }
      })
    },
    xiazaiFn (row, n) {
      if (n == 1) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.onePathDown// 后更改页面地址
      }
      if (n == 3) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.threePathDown // 后更改页面地址
      }
      if (n == 2) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.twoPathDown // 后更改页面地址
      }
    },
    kookFN (row, n) {
      if (n == 1) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.onePathLook// 后更改页面地址
      }
      if (n == 3) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.threePathLook // 后更改页面地址
      }
      if (n == 2) {
        let tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = row.twoPathLook // 后更改页面地址
      }
    },
    alityClick () {

    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },

    // 获取列表
    getList (searchFrom) {
      this.loading = true
      driverAgreementList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
</style>
